import React from 'react'
import {
  Flex,
  Stat,
  StatArrow,
  StatHelpText,
  Text
} from '@chakra-ui/react'
import { PriceDisplayProps } from '../types'
import { formatPrice } from '../utils'

const PriceDisplay = ({ price, priceChangePercentage, symbol }: PriceDisplayProps) => (
  <Flex align="center" gap={2}>
    <Text fontSize="sm" color="gray.500">{symbol.toUpperCase()}</Text>
    <Text fontSize="2xl" fontWeight="bold">{formatPrice(price)}</Text>
    <Flex align="center">
      <Stat display="inline" mr={0}>
        <StatHelpText mb={0} display="flex" alignItems="center">
          <StatArrow 
            type={priceChangePercentage >= 0 ? 'increase' : 'decrease'} 
          />
          <Text 
            color={priceChangePercentage >= 0 ? 'green.500' : 'red.500'}
            fontWeight="bold"
          >
            {priceChangePercentage.toFixed(2)}%
          </Text>
        </StatHelpText>
      </Stat>
    </Flex>
  </Flex>
)

export default PriceDisplay
